// @flow
/* eslint-disable import/no-cycle */
import { createResponsiveStateReducer } from 'redux-responsive';
import snackbarSlice, {
  State as SnackbarState
} from '@justpark/snackbar/src/reducers/snackbar';
import authSlice, { State as AuthState } from './auth';
import searchSlice, { State as SearchState } from './search';
import consentsSlice, { State as ConsentsState } from './consents';
import seasonTicketsFormSlice from './forms/seasonTickets';
import uiSlice, { State as UIState } from './ui';
import brandSlice, { State as BrandState } from './brand';
import vehicleSlice, { State as VehicleState } from './vehicle';
import { reducer as form } from '../components/Decorators/form';
import featuresSlice, { State as FeatureState } from './features';
import geolocationSlice, { State as GeolocationState } from './geolocation';
import breakpoints from './browser';
import paymentsSlice, { State as PaymentsState } from './payments';
import partnerSlice from './partner';
import evWelcomeSlice from './evWelcome';
import promotionsSlice from './promotions';
import launchDarklySlice from './launchDarkly';
import type { State as PromotionsState } from './promotions';
import monthlyCheckoutSlice, {
  State as MonthlyCheckoutState
} from './monthlyCheckout';

export type State = {
  payments: PaymentsState,
  consents: ConsentsState,
  search: SearchState,
  auth: AuthState,
  geolocation: GeolocationState,
  browser: any,
  brand: BrandState,
  ui: UIState,
  vehicle: VehicleState,
  features: FeatureState,
  snackbar: SnackbarState,
  monthlyCheckout: MonthlyCheckoutState,
  promotions: PromotionsState
};

export type Store = {
  getState: () => State
};

export const reducers = () => ({
  [paymentsSlice.name]: paymentsSlice.reducer,
  [authSlice.name]: authSlice.reducer,
  [featuresSlice.name]: featuresSlice.reducer,
  [searchSlice.name]: searchSlice.reducer,
  [consentsSlice.name]: consentsSlice.reducer,
  browser: createResponsiveStateReducer(breakpoints),
  [seasonTicketsFormSlice.name]: seasonTicketsFormSlice.reducer,
  form,
  [geolocationSlice.name]: geolocationSlice.reducer,
  [brandSlice.name]: brandSlice.reducer,
  [uiSlice.name]: uiSlice.reducer,
  [vehicleSlice.name]: vehicleSlice.reducer,
  [snackbarSlice.name]: snackbarSlice.reducer,
  [partnerSlice.name]: partnerSlice.reducer,
  [evWelcomeSlice.name]: evWelcomeSlice.reducer,
  [monthlyCheckoutSlice.name]: monthlyCheckoutSlice.reducer,
  [promotionsSlice.name]: promotionsSlice.reducer,
  [launchDarklySlice.name]: launchDarklySlice.reducer
});

export default reducers;
